import {
  OrderByOptionItemButton,
  SearchAreaContainer,
} from 'components/Blog/SearchArea';
import { EventContextState, useEventContext } from 'context/EventContext';
import { Dropdown } from 'dropdown';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import EventSearchForm from './EventSearchForm';

type EventStatusItem = {
  label: { ko: string; en: string };
  value: string;
};

export const statusItems: EventStatusItem[] = [
  { label: { ko: '전체', en: 'ALL' }, value: 'all' },
  { label: { ko: '진행중', en: 'In Progress' }, value: 'inprogress' },
  { label: { ko: '예정', en: 'Scheduled' }, value: 'scheduled' },
  { label: { ko: '종료', en: 'Closed' }, value: 'closed' },
];

const EventSearchArea = () => {
  const { locale } = useRouter();
  const {
    state: { status },
    dispatch,
  } = useEventContext();
  const currentStatusLabel = useMemo(
    () => statusItems.find(value => value.value === status).label[locale],
    [status, locale]
  );
  const handleChangeOrder = (e, status: EventContextState['status']) =>
    dispatch({ type: 'change', newState: { status, currPageNum: 0 } });

  return (
    <EventSearchAreaContainer>
      <Dropdown
        disabled={false}
        changeStyle
        displayBorder={false}
        onChange={handleChangeOrder}
        isPositionFixed={false}
      >
        <Dropdown.Toggle
          style={{ minWidth: locale === 'ko' ? '80px' : '120px' }}
        >
          {currentStatusLabel}
        </Dropdown.Toggle>
        <Dropdown.OptionList>
          {statusItems.map(statusValue => (
            <Dropdown.OptionItem
              key={statusValue.value}
              selected={status === statusValue.value}
              disabled={status === statusValue.value}
              value={statusValue.value}
              label={statusValue.label[locale]}
              tabIndex={-1}
            >
              <OrderByOptionItemButton>
                {statusValue.label[locale]}
              </OrderByOptionItemButton>
            </Dropdown.OptionItem>
          ))}
        </Dropdown.OptionList>
      </Dropdown>

      {/* Search form */}
      <EventSearchForm />
    </EventSearchAreaContainer>
  );
};

export default EventSearchArea;

const EventSearchAreaContainer = styled(SearchAreaContainer)``;
